import React from 'react';
import { toast } from 'react-toastify';

import CustomToast, { ToastType } from '../components/CustomToast';

const useToast = (defaultType: ToastType = 'info') => {
  const toastId = React.useRef(null);

  const show = (text: React.ReactNode, type: ToastType = defaultType) => {
    if (!toast.isActive(toastId.current)) {
      toastId.current = toast(
        <CustomToast
          text={text}
          type={type}
          onDismiss={() => toast.dismiss()}
        />,
        {
          theme: 'colored',
          type,
        },
      );
    }
  };

  return {
    show,
  };
};

export default useToast;
